export const SCAN_ACCEPT_MIME_TYPES = [
  "application/pdf",
  "image/jpeg",
  "image/png",
  "image/tiff",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
];

export const SCAN_ACCEPT_EXT_LABEL = "pdf、jpg、jpeg、png、tif、tiff、docx、xlsx、pptx";

export const DOCX_MIME_TYPE = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";

export type ScanPreviewType = "tiff" | "image" | "pdf" | "docx" | "office";

export const getScanPreviewType = (mime: string): ScanPreviewType => {
  if (mime.includes("tiff") || mime.includes("tif")) return "tiff";
  if (mime.startsWith("image/")) return "image";
  if (mime === "application/pdf") return "pdf";
  // if (mime === DOCX_MIME_TYPE) return "docx";
  return "office";
};
